import { render } from "./AddSections.vue?vue&type=template&id=2a557e30&scoped=true"
import script from "./AddSections.vue?vue&type=script&lang=js"
export * from "./AddSections.vue?vue&type=script&lang=js"

import "./AddSections.vue?vue&type=style&index=0&id=2a557e30&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a557e30"]])

export default __exports__